const PHP_IANA_TIMEZONE_ALIASES: Readonly<Record<string, string>> = {
  'America/Godthab': 'America/Nuuk',
  'Asia/Calcutta': 'Asia/Kolkata',
  'Asia/Katmandu': 'Asia/Kathmandu',
  'Asia/Rangoon': 'Asia/Yangon',
  'Asia/Saigon': 'Asia/Ho_Chi_Minh',
  'Europe/Kiev': 'Europe/Kyiv',
  'Pacific/Enderbury': 'Pacific/Kanton',
  'Pacific/Ponape': 'Pacific/Pohnpei',
  'Pacific/Truk': 'Pacific/Chuuk',
}

const UTC_ALIASES = new Set(['Etc/GMT', 'Etc/UCT', 'Etc/UTC', 'GMT', 'UCT', 'Zulu'])

function normalizeCandidate(timezone: string | null | undefined): string | null {
  const resolved = timezone?.trim()
  if (!resolved) return null
  if (UTC_ALIASES.has(resolved)) return 'UTC'

  const normalized = PHP_IANA_TIMEZONE_ALIASES[resolved] ?? resolved
  if (normalized === 'UTC') return normalized
  if (normalized.startsWith('Etc/')) return null
  if (!/^[A-Za-z_+-]+(?:\/[A-Za-z0-9_+.-]+)+$/.test(normalized)) return null

  return normalized
}

/**
 * Browsers use ICU/CLDR timezone canonicalization while PHP validates against its IANA tzdata.
 * Some browsers therefore return legacy identifiers (notably Asia/Saigon) rejected by Laravel's
 * `timezone:all` rule. Normalize those identifiers before persisting or sending offline commands.
 */
export function normalizeDeviceTimezone(
  timezone: string | null | undefined,
  fallback: string | null | undefined = 'UTC',
): string {
  return normalizeCandidate(timezone) ?? normalizeCandidate(fallback) ?? 'UTC'
}
